import __request__ from 'routing/request';
type DataLakeInfoArray = DataLakeInfo[];
interface DataLakeInfo {
    readonly storage_type: 'ICEBERG' | 'AWS_SEC_DATA_LAKE';
    readonly active: boolean;
    readonly id: string;
    readonly type: 'INTERNAL' | 'EXTERNAL';
    readonly title: string;
}
type FilterTypeInfoArray = FilterTypeInfo[];
interface FilterTypeInfo {
    readonly class: string;
    readonly in_memory_filter: boolean;
    readonly normalize_value: boolean;
    readonly field_name: string;
}
/**
 * Get information about active Data Lakes
 */
export function getActive(): Promise<DataLakeInfoArray> {
    return __request__('GET', '/plugins/org.graylog.plugins.datawarehouse/data_lakes/active', null, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Get information about all Data Lakes
 */
export function getAll(): Promise<DataLakeInfoArray> {
    return __request__('GET', '/plugins/org.graylog.plugins.datawarehouse/data_lakes/all', null, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Get information about filterable fields for a given Data Lake
 */
export function getFilterableFields(data_lake_id?: string, table_id?: string): Promise<FilterTypeInfoArray> {
    return __request__('GET', `/plugins/org.graylog.plugins.datawarehouse/data_lakes/filterable_fields/${data_lake_id}`, null, { 'table_id': table_id }, {
        'Accept': ['application/json']
    });
}
